import { TFunction } from "i18next";
import { z } from "zod";
import { nullableNumber } from "../../../utils";

export const getMethodsInputFormSchema = (t: TFunction) => {
  const numberField = nullableNumber(t("generic.errors.invalid-number"));

  return z.object({
    name: z.string().min(1, {
      message: t("calculations.methods-input.errors.name-required"),
    }),

    exploitationFlow: numberField.optional(),
    testFlow: numberField.optional(),
    flowM3Day: numberField.optional(),
    flowM3Hour: numberField.optional(),
    hydrostaticLevel: numberField.optional(),
    hydrodynamicLevel: numberField.optional(),
    transmissivity: numberField.optional(),
    hydraulicConductivity: numberField.optional(),
    hydraulicGradient: numberField.optional(),

    effectivePorosity: numberField
      .optional()
      .refine(
        (value) => value == null || (value >= 0 && value <= 1),
        {
          message: t("calculations.methods-input.errors.effective-porosity-range"),
        }
      ),

    storageCoefficient: numberField.optional(),
    recharge: numberField.optional(),

    saturatedThickness: numberField.optional(),
    saturatedThicknessTop: numberField.optional(),
    saturatedThicknessBase: numberField.optional(),

    aquiferType: numberField.optional(),
  }).superRefine((data, ctx) => {
    if (
      data.saturatedThicknessTop != null &&
      data.saturatedThicknessBase != null &&
      data.saturatedThicknessBase < data.saturatedThicknessTop
    ) {
      ctx.addIssue({
        path: ["saturatedThicknessBase"],
        code: z.ZodIssueCode.custom,
        message: t("calculations.methods-input.errors.base-must-be-greater-than-top"),
      });
    }
  });
};

export type MethodsInputForm = z.infer<ReturnType<typeof getMethodsInputFormSchema>>;